import { Alert, Button, Card as AntdCard, Checkbox, Form, message, Popconfirm, Select, Space, Row, Col, Input, Modal } from 'antd'
import React from 'react'
import { api, app, use } from 'xadmin'
import { HasPermission } from 'xadmin-auth'
import { C, Icon } from 'xadmin-ui'
import ModelIconPicker from '../../components/ModelIconPicker'
import NodeTreeSelect from '../../components/NodeTreeSelect'
import { ParentNodeFilter } from '../../components/ParentNodeSelect'
import NoData from './../../components/NoData'
import FocusIcon from './components/FocusIcon'
import RelationWrap from './components/Relation'
import Tag from './components/Tag'
import TypeSelect from './components/TypeSelect'
import UploadButton from './components/UploadButton'
import UidComponent from './../../components/UidComponent'
import { ArrowLeftOutlined } from '@ant-design/icons'
import _ from 'lodash'

const BatchFocusComponents = ({ input, label, field, meta, group: FieldGroup, }) => {
  const { modelState: { wheres, selected, ids, count }, modelDispatch } = use('model')
  const [val, setVal] = React.useState(input.value)
  const countv = React.useRef(count)

  if (countv.current != count) modelDispatch({ type: 'SELECT_CLEAR' })

  React.useEffect(() => {
    if (wheres?.filters?.focus) setVal(true)
  }, [selected])

  const onChange = (e) => {
    setVal(e.target.checked)
    input.onChange(e.target.checked)
  }

  return (
    <FieldGroup meta={meta} input={input} field={field} tailLayout={true}>
      <Checkbox onChange={onChange} checked={!!val}  {...field.attrs} >{label}</Checkbox>
    </FieldGroup>
  )
}
BatchFocusComponents.useGroup = false

const FocusCheckboxComponent = ({ input, label, field, meta, group: FieldGroup }) => {
  return (
    <FieldGroup meta={meta} input={input} field={field} tailLayout={true}>
      <Checkbox checked={!!input.value} {...input} {...field.attrs} >{label}</Checkbox>
    </FieldGroup>
  )
}
FocusCheckboxComponent.useGroup = false

const Delete = ({ id }) => {
  const [Checkboxs, setCheckboxs] = React.useState(false)
  const { modelDispatch } = use('model')

  function confirm(e) {
    if (id) {
      let url = Checkboxs ? `/${id}?cascade=${Checkboxs}` : `/${id}`
      api({ name: 'core/node' })
        .fetch(url, { method: 'DELETE' })
        .then(({ status }) => {
          if (status == 200) {
            message.success(Checkboxs ? '级联删除成功' : '删除成功')
            modelDispatch({ type: 'GET_ITEMS' })
          }
        })
    }
  }

  function onChange(e) {
    setCheckboxs(e.target.checked || '')
  }

  return (
    <Popconfirm
      title={<Checkbox onChange={onChange}>是否级联删除？</Checkbox>}
      icon={<Icon name="question-circle-o" style={{ color: 'red' }} />}
      onConfirm={confirm} okText="确定" cancelText="取消">
      <HasPermission permission="node.delete">
        <Button><Icon type="delete" /></Button>
      </HasPermission>
    </Popconfirm>
  )
}

const Model = {
  type: 'object',
  name: 'model',
  resource: 'core/model',
  title: '模型',
  // "forceGetItem": true,
  properties: {
    name: {
      title: '模型名称',
      type: 'string',
      maxLength: 15,
      description: '模型名称不能输入特殊字符'
    },
    kind: {
      title: '资产类型',
      type: 'string',
      description: '选择资产类型对资产进行分类管理，资产类型在【模块配置】中自定义添加'
    },
    icon: {
      title: '模型图标',
      type: 'string',
      description: '可上传PNG/JPG/SVG/GIF格式, 图标大小不可超过500kb'
    },
    order: {
      title: '显示顺序',
      type: 'number',
    },
    tag: {
      title: '模型标签',
      type: 'array',
      items: {
        // type: 'string',
      },
    },
    relations: {
      title: '模型关系',
      type: 'object',
      description: '通过模型可以统一定义资产之间的父子级关系，具有父子级关系的模型，数据可以实现父级对子级数据的直接映射',
      properties: {},
    },
  },
  listFields: ['name', 'kind', 'icon', 'order', 'tag', 'relations'],
  projectFields: ['device', 'dashboard', 'table', 'warning'],
  required: ['name'],
  is_extend: true,
  partialSave: true,
  forceGetItem: true,
  permission: {
    add: true,
    edit: true,
    view: true,
    delete: true,
  },
  initialValues: {
    filter: {
      limit: 999999,
    },
  },
  form: [{
    key: 'name',
    // validate: value => (/^[A-Za-z0-9\u4e00-\u9fa5]+$/ig.test(value) ? null : '名称不合法！'),
    // description: '名称只能是汉字、字母或数字。',
  },
  {
    key: 'kind',
    component: TypeSelect
  },
  {
    key: 'tag',
    component: Tag,
  },
  {
    key: 'relations',
    component: RelationWrap,
  },
  {
    key: 'icon',
    component: ModelIconPicker,
  },
  ],
}

const NodeFormLayout = props => {
  const { children, invalid, handleSubmit, submitting } = props
  const { form } = use('form')
  const { _t } = app.context
  const groupProps = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 18, offset: 5 }
    }
  }

  const nodeId = form.getState().values.id

  return (
    <Form onSubmit={handleSubmit}>
      {children}
      <Form.Item {...groupProps}>
        <Space>
          <Button type="primary" onClick={() => {
            if (!nodeId) { form.data.__next = 'edit' }
            return handleSubmit()
          }} loading={submitting} disabled={invalid}>{_t('Save')}</Button>

          {nodeId == undefined ? <>
            <Button type="primary" onClick={() => {
              form.data.__next = 'next'
              return handleSubmit()
            }} loading={submitting} disabled={invalid}>保存并添加下一条</Button>
            <Button type="primary" onClick={() => {
              form.data.__next = 'list'
              return handleSubmit()
            }} loading={submitting} disabled={invalid}>保存并返回列表</Button>
          </>
            : null}
          <Button onClick={() => history.back()}>{_t('Cancel')}</Button>
        </Space>
      </Form.Item>
    </Form>
  )
}

const Node = {
  type: 'object',
  name: 'node',
  icon:
    <>
      <ArrowLeftOutlined onClick={() => history.back()} />
      <Icon svg={require('./../../icon/Node.svg')} />
    </>,
  resource: 'core/node',
  title: '资产',
  forceGetItem: true,
  userPageFields: true,
  properties: {
    name: {
      title: '名称',
      type: 'string',
      width: 150,
      maxLength: 128,
      column: { fixed: 'left' },
    },
    department: {
      type: 'array',
      title: '所属部门',
      width: 150,
      fieldType: 'department',
      canOrder: true,
      description: '按照实际情况添加资产的所属部门，当资产未选择所属部门，具有资产查看权限的用户都可以看到该资产',
      items: {
        type: 'object',
        name: '部门',
        properties: {
          name: {
            type: 'string'
          }
        },
      },
    },
    parent: {
      type: 'array',
      title: '所属资产',
      fieldType: 'parentnode',
      width: 150,
      canOrder: true,
      items: {
        type: 'object',
        name: '资产',
        properties: {
          name: {
            type: 'string',
          }
        },
      },
    },
    users: {
      type: 'array',
      title: '用户列表',
      notInclude: true,
      description: '管理当前资产的用户',
      items: {
        type: 'object',
        name: 'User',
        relateTo: 'User',
        properties: {
          Id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    uid: {
      title: '编号',
      type: 'string',
      width: 150,
      maxLength: 40,
      description: '编号必须为汉字、字母、数字、特殊字符!@$-_:'
    },
    model: {
      title: '模型',
      type: 'object',
      fieldType: 'model',
      width: 150,
      properties: {
        name: {
          title: '模型名称',
          type: 'string'
        }
      },
    },
    status: {
      title: '状态',
      type: 'string',
      width: 80,
    },
    remark: {
      title: '备注',
      type: 'string',
      width: 350,
    },
    online: {
      title: '在线',
      type: 'boolean',
      width: 80,
      boolLabel: ['在线', '掉线']
    },
    off: {
      title: '断电',
      type: 'boolean',
      width: 100,
      boolLabel: ['断电', '上电']
    },
    disable: {
      title: '禁用',
      type: 'boolean',
      width: 80,
    },
    connectTime: {
      title: '通信时间',
      type: 'string',
      width: 250,
      format: 'date-time',
    },
    createTime: {
      title: '创建时间',
      type: 'string',
      width: 250,
      format: 'date-time',
    },
    creator: {
      title: '创建人',
      relateTo: '',
      width: 100,
      type: 'string',
    },
    modifyTime: {
      title: '更新时间',
      type: 'string',
      width: 250,
      format: 'date-time',
    },
    focus: {
      title: '关注',
      width: 50,
      type: 'boolean',
      field: { component: BatchFocusComponents }
    }
  },
  is_extend: true,
  partialSave: true,
  listFields: ['name', 'uid', 'parent', 'status', 'connectTime', 'online', 'off', 'remark'],
  projectFields: ['custom', 'focus', 'device'],
  required: [
    'name', 'uid', 'model'
  ],
  filters: {
    submenu: [
      'name', 'uid',
      'model',
      'department',
      { key: 'parent', component: ParentNodeFilter },
      { key: 'online', boolLabel: ['在线', '掉线'] },
      { key: 'off', boolLabel: ['断电', '上电'] },
      'remark'
    ],
  },
  editableFields: ['name', 'off', 'disable', 'remark'],
  batchChangeFields: ['disable', 'focus'],
  // export_files: ['xlsx'],
  permission: {
    add: true,
    edit: true,
    view: true,
    delete: true,
  },
  form: [
    'model',
    {
      key: 'name',
      validate: value => {
        return (/^[\u2E80-\u9FFF\w\-\_\!\@\$\#\:]{1,}$/ig.test(value) ? null : '名称必须为汉字、字母、数字、特殊字符!@$-_:#')
      },
    },
    {
      key: 'uid',
      validate: value => {
        return (/^[\u2E80-\u9FFF\w\-\_\!\@\$\#\:]{1,}$/ig.test(value) ? null : '编号必须为汉字、字母、数字、特殊字符!@$-_:#')
      },
      component: (props) => <UidComponent type={'node'} {...props} />
    },
    'department', 'parent', 'users',
    'off', { key: 'focus', component: FocusCheckboxComponent }, 'disable', 'remark'
  ],
  formProps: {
    onSubmitSuccess: (value, form) => {
      if (form.data.__next == 'next') {
        message.info('请添加新一条资产信息')
        app.go('/app/nodes?model=' + value.model.id)
        app.go('/app/model/node/add?modelId=' + value.model.id)
        return null
      } else if (form.data.__next == 'list') {
        app.go('/app/nodes?model=' + value.model.id)
      } else if (form.data.__next == 'edit' && value.id) {
        app.go('/app/nodes?model=' + value.model.id)
        app.go(`/app/model/Node/${value.id}/edit`)
      }
    },
  },
  formEffect: form => {
    ['id', 'name'].forEach(name => {
      form.useField(name, ({ value }) => {
        const formState = form.getState()
        if (formState.submitErrors && formState.submitErrors[name]) {
          delete formState.submitErrors[name]
          form.resetFieldState(name)
        }
      })
    })
  },
  blocks: {
    'model.list.navbtn': (props) =>
      [
        <UploadButton title="导入资产" />,
        <HasPermission permission="record.view">
          <Button type="primary" onClick={() => app.go('/app/changeNotes')}>资产变更记录</Button>
        </HasPermission>,
      ]
  },
  dataTableProps: (columns) => {
    const isHs = _.isEmpty(app.apps.find(item => item.name === 'iot-xj-hs'))
    let _columns = columns
    if (isHs) {
      _columns = _.filter(columns, item => item.key !== "status")
    }
    return {
      scroll: { x: 1500 },
      columns: _columns.map(c => c.key == '__action__' ? { ...c, width: 280 } : { ...c, width: c.width || 100 })
    }
  },
  itemActions: [
    ({ item }) => <Button onClick={() => app.go(`/app/model/node/${item.id}/view`)}>画面</Button>,
    ({ item }) => <Button onClick={() => app.go('/app/nodes?parent=' + item.id)}>子资产</Button>,
    ({ item }) => <HasPermission permission="record.view"><Button onClick={() => { app.go(`/app/assetsNotes?id=${item.id}`) }}>记录</Button></HasPermission>,
    'edit',
    ({ item }) => <Delete {...item} />,
    ({ item }) => (<FocusIcon button item={item} />)
  ],
  components: {
    AddButton: (props) => <AddButton {...props} />,
    DataEmpty: props => <AntdCard><NoData /></AntdCard>,
    DataForm: (props) => <DataForm {...props} />
  },
  convertItem: node => ({ ...node, uid: node.uid || node.id })
}

const DataForm = (props) => {
  const [model, setModel] = React.useState(null)
  const { query, id } = props
  const modelId = query?.modelId || props?.modelId
  // 获取模型
  const param = id ? { ...props } : { ...props, data: { model } }

  React.useEffect(() => {
    modelId && api('Model').get(modelId).then(json => setModel(json))
  }, [])

  return (
    <>
      {/* {modelId ? <Alert message="请优先填写基本信息，除基础信息外，当前资产已继承模型的所有配置，页面不显示，若需单独配置，用户在页面进行单独设置即可！"
        style={{ marginBottom: 10 }}
        type="error" closable showIcon /> : null} */}
      {/* 当资产id存在时再显示其他tab项 */}
      <C is="Model.TabsForm"
        {...param}
        schemaKey="node.schema"
        componentClass={props?.componentClass ? props?.componentClass : id ? null : NodeFormLayout}
      />
      {/* <C is="Model.TabsForm"  {...param}
        componentClass={id ? null : NodeFormLayout}
      /> */}

    </>
  )
}

function getUrlParameter(parameterName) {
  const url = window.location.href;
  const regex = new RegExp('[?&]' + parameterName + '=([^&#]+)');
  const match = url.match(regex);
  if (match) {
    return decodeURIComponent(match[1]);
  } else {
    return null;
  }
}


const AddButton = (props) => {
  const { children } = props
  const [node, setNode] = React.useState(null)

  let string = location.href.slice(location.href.lastIndexOf('='), location.href.length)
  const query = string || null
  const nodeId = getUrlParameter('parent')
  const modelId = getUrlParameter('model')


  React.useEffect(() => {
    nodeId && api('Node').get(nodeId).then(json => setNode(json))
  }, [nodeId])

  let url = null
  if (location.href && location.href.indexOf('?_s=') != -1) {
    url = '/app/model/node/add'
  } else {
    url = `/app/model/node/add?modelId=${node?.model?.id || modelId || ''}`
    if (nodeId) {
      url += `&parentId=${nodeId}`
    }
  }

  return <Button type="primary" onClick={() => app.go(url)}>{children}</Button>
}

const FieldGroup = ({ label, meta, input, field, children }) => {
  const attrs = field.attrs || {}
  const error = meta.touched && meta.error
  const extra = field.description || field.help
  const size = { labelCol: { sm: { span: 8 } }, wrapperCol: { sm: { span: 16 } } }

  const groupProps = { extra, ...size, required: field.required, labelAlign: 'right' }

  if (error) {
    groupProps['validateStatus'] = 'error'
    groupProps['help'] = error
  }

  const controlComponent = children ? children : (<Input {...input} {...attrs} />)
  return (


    <Col span={8} sm={12} xs={24} md={12} lg={8} xl={8} xxl={6}>
      <Form.Item colon={false} label={label} {...groupProps}>
        {controlComponent}
      </Form.Item>
    </Col>


  )
}

const NodeListSelect = ({ field, ...props }) => {
  const { model, department } = use('form', state => ({
    model: state.values && state.values.model,
    department: state.values && state.values.department
  }))
  return <C is="NodeListSelect" field={{ ...field, model, department }} {...props} />
}

const Record = {
  title: '资产变更记录',
  type: 'object',
  name: 'record',
  resource: 'core/record',
  properties: {
    data: {
      type: 'string',
      title: '名称'
    },
    department: {
      type: 'array',
      title: '部门选择',
      fieldType: 'department',
      items: {
        type: 'object',
        name: '部门',
        properties: {},
      },
    },
    node: {
      type: 'object',
      title: '资产选择',
      properties: {}
    },
    model: {
      title: '模型',
      type: 'object',
      fieldType: 'model',
      properties: {
        name: {
          type: 'string'
        }
      },
    },
    id: {
      type: 'string',
      title: 'ID'
    },
    message: {
      type: 'string',
      title: '信息'
    },
    time: {
      type: 'string',
      title: '时间',
      format: 'date-time',
      // fieldType: 'date-time'
    },
    type: {
      type: 'string',
      title: '类型',
      enum: ['操作记录', '故障记录', '普通记录', '修改备注'],
      enum_title: ['操作记录', '故障记录', '普通记录', '修改备注']
    },
    user: {
      title: '人员选择',
      type: 'object',
      relateTo: 'User',
      properties: {
        id: {
          title: 'id',
          type: 'string'
        },
        name: {
          title: '人员',
          type: 'string'
        }
      }
    },
    // nodeId: {
    //   title: 'nodeId',
    //   type: 'string'
    // }
  },
  orders: { time: 'DESC' },
  filters: {
    submenu: [
      'time',
      'user',
      'model', 'department',
      // { key: 'node', component: NodeTreeSelect },
      { key: 'node', group: FieldGroup, component: NodeListSelect }
    ]
  },
  components: {
    DataEmpty: props => <AntdCard><NoData /></AntdCard>
  },
  forceGetItem: true,
  permission: {
    view: true,
    add: true,
    edit: false,
    delete: false
  },
  batchActions: null,
  listFields: ['time', 'node', 'department', 'user', 'type', 'message', 'data'],
  form: ['time', { key: 'node', component: NodeTreeSelect }, 'department', 'user', 'type', 'message', 'data']
}

export default {
  Model,
  Node,
  Record
}

export { DataForm }
